/* !
 * index.js v1.0.0
 * Copyright, Connecty Inc.
 */
( ( FUNCTIONS ) => {
	const a = 'is-active';
	const v = 'is-visible';

	const tag = () => {
		const tag = document.querySelectorAll('.cf_n_tags')
		for (let i = 0; i < tag.length; i++) {
			if (!tag[i].children.length) {
				tag[i].remove();
			}
		}
	};

	tag();


} )( window.FUNCTIONS );
